let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedDescription = styledWithTheme.pre(_t || (_t = _`
  font-family: var(--web-font-family);
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  line-height: ${0};
  overflow-y: hidden;
  word-break: break-word;
  margin-top: ${0};
  margin-bottom: ${0};
  color: ${0};
  font-size: ${0};
`), ({
  theme
}) => theme.typography['detail-200'].lineHeight, ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.color['text-core-subtle'], ({
  theme
}) => theme.typography['detail-100'].fontSize);
const LineItemDescription = ({
  description
}) => /*#__PURE__*/_jsx(FormattedDescription, {
  "data-test-id": "line-item-description",
  children: description
});
export default LineItemDescription;